import { render, staticRenderFns } from "./GiftShoppingCartMobile.vue?vue&type=template&id=658ede74"
import script from "./GiftShoppingCartMobile.vue?vue&type=script&lang=js"
export * from "./GiftShoppingCartMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports